<section class="py-6 border-b border-b-shs-gray-4" [formGroup]="form!">
    <h2 class="text-base font-bold text-font-primary">Affected Items</h2>
    <div class="mt-4 flex flex-col gap-4">
        <sag-ui-select
            [required]="true"
            label="Damage Type"
            placeholder="Select Damage Type"
            formControlName="damageType"
            class="max-w-input"
        >
            @for (item of damageTypes | keyvalue; track $index) {
            <sag-ui-option [value]="item.value">{{ item.value }}</sag-ui-option>
            }
        </sag-ui-select>
        <sag-ui-select
            [required]="true"
            label="Item Type"
            placeholder="Select Item Type"
            formControlName="itemType"
            class="max-w-input"
        >
            @for (item of itemTypes | keyvalue; track $index) {
            <sag-ui-option [value]="item.value">{{ item.value }}</sag-ui-option>
            }
        </sag-ui-select>
        @if(showError) {
        <div class="rounded-md bg-shs-red grid grid-cols-[50px_auto] shadow-md items-center p-4 max-w-[950px]">
            <span class="icon-circle-error text-white text-3xl"></span>
            <span class="text-white text-sm font-bold pr-8"
                >You must report product discrepancies to your respective appropriate Remote Service Center (RSC)
                channel for assessment of the discrepancy and determination of the need for corrective action.</span
            >
        </div>
        }
        <app-order-line-table
            [selected]="lineItems"
            [disabled]="disabled"
            (selectionChange)="handleSelectionChange($event)"
            currency="USD"
        ></app-order-line-table>
        @if (!disabled) {
        <div class="flex items-center justify-end max-w-[1400px]">
            <sag-ui-button [disabled]="!valid || confirmed" (click)="setConfirmed()" size="sm">{{
                confirmed ? 'Confirmed' : 'Confirm'
            }}</sag-ui-button>
        </div>
        }
    </div>
</section>
